import { createAuthClient } from 'better-auth/client';
import { organizationClient } from 'better-auth/client/plugins';

// Platform-standard token key (matches @cormirus/shared AUTH_TOKEN_KEY)
export const AUTH_TOKEN_KEY = 'ao_auth_token';

type AuthClient = ReturnType<typeof createAuthClient>;

const authClient: AuthClient = createAuthClient({
  baseURL: import.meta.env.VITE_AUTH_URL || 'http://localhost:3002',
  plugins: [organizationClient()],
  fetchOptions: {
    credentials: 'include',
    auth: {
      type: 'Bearer',
      token: () => {
        if (typeof window !== 'undefined') {
          return localStorage.getItem(AUTH_TOKEN_KEY) || '';
        }
        return '';
      },
    },
  },
});

export default authClient;
